import { Component, OnInit } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { formatDate, DatePipe } from '@angular/common';
import { Md5 } from 'ts-md5/dist/md5'
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'; 
import { environment } from "environments/environment";

//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import * as moment from "moment";


@Component({
  selector: 'app-changuepass',
  templateUrl: './changuepass.component.html',
  styleUrls: ['./changuepass.component.css']
})
export class ChanguepassComponent implements OnInit {
usuario;
pre1be;
pre2be;
res1be;
res2be;
res1fe;
res2fe;
newpass1;
newpass2;
error;
errorpreguntas;

constructor(
  private http: HttpClient,
  private datePipe: DatePipe,
  private _router: Router,
  
  //snackbar 2
  public snackBar: MatSnackBar
  
  ) {
    this.error=false; 
    this.errorpreguntas=false;
  }

  ngOnInit() {
    this.usuario=localStorage.getItem('userId');
    this.getPreguntas();
    //this.pre1be=localStorage.getItem('pre1be');
    //this.pre2be=localStorage.getItem('pre2be');
    //this.res1be=localStorage.getItem('res1be');
    //this.res2be=localStorage.getItem('res2be');
  }

  loading = false;
  getPreguntas(){
    this.loading=true;
    //http://localhost:1337/api/changepass/getpregs?id=pablopalacio
    this.http.get(`${environment.backendUrl}/api/changepass/getpregs?id=${this.usuario}`)
      .subscribe((datos: any[]) => {
        if(datos){
          this.pre1be = datos[0]["pregunta1"];
          this.pre2be = datos[0]["pregunta2"];
          this.res1be = datos[0]["respuesta1"];
          this.res2be = datos[0]["respuesta2"];
          console.log(this.pre1be);
          console.log(this.pre2be);
          console.log(this.res1be);
          console.log(this.res2be);
          this.loading=false;
        }else{
          console.warn("NO HAY");
          this.loading=false;
        };
      });
  }
  

  validarPreguntas(){
    this.errorpreguntas=false;
    if((this.res1be==this.res1fe) && (this.res2be==this.res2fe) ){
      console.log("paso!");
      this.errorpreguntas=false;
      document.getElementById("abremodalpass").click(); 
    }else{
      console.log("no paso!");
      this.errorpreguntas=true;
    }
    console.log(this.errorpreguntas);
  }
  
  validarPass(){
    this.error=false;
    if(this.newpass1 == this.newpass2){   
      console.log(this.newpass1);
      console.log(this.newpass2); 
      console.log("iguales");
      this.error==false; 
      this.cambiar();
      //document.getElementById("cierraModal").click(); 
    }else{
      this.error=true;
      console.log(this.newpass1);
      console.log(this.newpass2);
      console.log("distintas");
    }

    console.log(this.error);
  }

  result;
  loading2=false;
  cambiar(){
    this.loading2 = true;
    var body = {
      "id": `${this.usuario}`,
      "pass": `${Md5.hashStr(this.newpass1)}`
    };
    //http://localhost:1337/api/changepass/cambiarpass
    this.http.post(`${environment.backendUrl}/api/changepass/cambiarpass`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
        console.log("STATUS REQUEST: " + status.status)
        if (status.status == 200){
          console.warn("post OK!");   
          this.loading2=false;
          this.snackBar.open(`Contraseña Actualizada!`, 'Cerrar', {duration: 5000});
          document.getElementById("cierraModal").click();
          this._router.navigate(['/home']);
        }
        if (status.status == 500){
          console.warn("ERROR POST!");
          console.log(JSON.stringify(status["error"]["code"]));
          this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
          this.loading2=false;
        }else{
          //this.snackBar.open(`ERROR DESC.. `, 'Cerrar', {duration: 5000});
          this.loading2 = false;
        }
      }
    )
  }
  


}
